import { Dimensions } from "react-native";
export default () => Dimensions.get("window").width;
